import React from "react";
import { Redirect } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Login from "./../pages/user/login.js";
import Register from "./../pages/user/register.js";
import RegisterSubscribe from "../pages/user/registerSubscribe.js";
import ForgetPassword from "../pages/user/forgetPassword.js";
import ResetPassword from "../pages/user/resetPassword.js";
import AdminHandoff from "../pages/user/adminHandoff.js";
import ChoosePanel from "../pages/package/package.js";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    "pk_live_51TcWrnEFp6E1oRogJ6ul5KZwwOONiiQlsq1WfQiz6KFzwtF6k4ktPHC1ykVZiWZd67Wl2S9UA71VlHxMEJBddZmL00RkevipOk"
);

const UnauthorizeRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/user/login" />,
  },
  {
    path: "/user/login",
    title: "Login",
    component: () => <Login />,
  },

  {
    path: "/user/admin-handoff",
    title: "Signing in",
    component: () => <AdminHandoff />,
  },

  {
    path: "/user/register",
    title: "Register",
    component: () => <Register />,
  },

  {
    path: "/user/register-subscribe",
    title: "Subscribe & Register",
    component: () => (
      <Elements stripe={stripePromise}>
        <RegisterSubscribe />
      </Elements>
    ),
  },

  {
    path: "/user/forgetPassword",
    title: "Forget Password",
    component: () => <ForgetPassword />,
  },

  {
    path: "/user/resetPassword/:token",
    title: "Reset Password",
    component: () => <ResetPassword />,
  },
  {
    path: "/user/packages",
    title: "Subscribe",
    component: () => <ChoosePanel />,
  },
  {
    path: "*",
    component: ({ location }) => {
      const path = location.pathname;

      if (path.includes("/user/resetPassword")) {
        return null;
      }

      return <Redirect to="/user/login" />;
    },
  },
];

export default UnauthorizeRoute;
